import { render } from "./AddMember.vue?vue&type=template&id=d4aa5136&scoped=true"
import script from "./AddMember.vue?vue&type=script&lang=js"
export * from "./AddMember.vue?vue&type=script&lang=js"

import "./AddMember.vue?vue&type=style&index=0&id=d4aa5136&scoped=true&lang=css"

import exportComponent from "/Users/nori/Dropbox (Nakajima Glass)/ngciio/ngci-members/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4aa5136"]])

export default __exports__